import { render, staticRenderFns } from "./SharedLinkRestoreFolder.vue?vue&type=template&id=31f3de9e&scoped=true&"
import script from "./SharedLinkRestoreFolder.vue?vue&type=script&lang=js&"
export * from "./SharedLinkRestoreFolder.vue?vue&type=script&lang=js&"
import style0 from "./SharedLinkRestoreFolder.vue?vue&type=style&index=0&id=31f3de9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f3de9e",
  null
  
)

export default component.exports